import { PlusOutlined } from '@ant-design/icons';
import { Input, Tag, Tooltip } from 'antd';
import { observer } from 'mobx-react';
import React from "react";
import TagsEditorStore from "../../../stores/common/tags-editor";
import './style.css';

const TagsEditor: React.FC<{data: TagsEditorStore}> = ({data}) => {

    const handleClose = (removedTag: string): void => {
        data.setTags(data.tags.filter(tag => tag !== removedTag));
    }

    const showInput = (): void => {
        data.setInputVisible(true);
    }

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        data.setInputValue(event.target.value);

    }

    const handleInputConfirm = (): void => {

        const { inputValue } = data;
        const { tags } = data;

        if (inputValue && tags.indexOf(inputValue) === -1) {
            data.setTags([...tags, inputValue]);
        }

        data.setInputVisible(false);
        data.setInputValue('');
    }

    const handleEditInputChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        data.setEditInputValue(event.target.value);
    }

    const handleEditInputConfirm = (): void => {
        data.editTags();
    }

    // const saveInputRef = (input: Input): void => {
    //     this.input = input;
    // }

    // const saveEditInputRef = (input: Input): void => {
    //     this.editInput = input;
    // }

    // const saveInputRef = useRef(null);
    // const saveEditInputRef = useRef(null);


    return (
        <div>
            {data.tags.map((tag, index) => {
                if (data.editInputIndex === index) {
                    return (
                        <Input
                            // ref={saveEditInputRef}
                            key={tag}
                            size="small"
                            className="tag-input"
                            value={data.editInputValue}
                            onChange={handleEditInputChange}
                            onBlur={handleEditInputConfirm}
                            onPressEnter={handleEditInputConfirm}
                        />
                    );
                }

                const isLongTag = tag.length > 20;

                const tagElem = (
                    <Tag
                        color="purple"
                        className="edit-tag"
                        key={tag}
                        closable={true}
                        onClose={() => handleClose(tag)}
                    >
                        <span
                            onDoubleClick={e => {
                                if (index !== 0) {
                                    data.setEditMode(index, tag);
                                    e.preventDefault();
                                }
                            }}
                        >
                            {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                        </span>
                    </Tag>
                );

                return isLongTag ? (
                    <Tooltip title={tag} key={tag}>
                        {tagElem}
                    </Tooltip>
                ) : (tagElem);
            })}
            {data.inputVisible && (
                <Input
                    // ref={saveInputRef}
                    type="text"
                    size="small"
                    className="tag-input"
                    value={data.inputValue}
                    onChange={handleInputChange}
                    onBlur={handleInputConfirm}
                    onPressEnter={handleInputConfirm}
                />
            )}
            {!data.inputVisible && (
                <Tag className="site-tag-plus" onClick={showInput}>
                    <PlusOutlined /> Добавить метку
                </Tag>
            )}
        </div>
    );
};

export default observer(TagsEditor);